
import { GAMETYPE_ID, Season } from "@/models/GameType";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ImageBox from "../../Base/ImageBox.vue";
import ChallengeBox from "../../Base/ChallengeBox.vue";
import ImageSelector from "../../Base/ImageSelector.vue";
import { ChallengeData } from "@/models/Base/ChallengeData";
import { isEqual, cloneDeep } from "lodash";

@Component({
  components: {
    ImageBox,
    ImageSelector,
    ChallengeBox,
  },
})
class GameTypeIntro extends Vue {
  @Prop({ default: "EN" }) readonly languageID!: string;
  @Prop({ default: null }) readonly seasonData!: Season;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  showSavePanel = false;
  seasonDataObject = {} as Season;
  showImageSelectorBool = false;

  get getGameTypeID(): GAMETYPE_ID {
    if (this.$store.state.gameStore.gameType.length > 0)
      return this.$store.state.gameStore.gameTypeSelected;
    return GAMETYPE_ID.MANHUNT;
  }

  get getAudioPath(): string {
    return (
      "/gametype/" +
      this.getGameTypeID +
      "/seasons/" +
      this.seasonData.slug +
      "/audio/misc/"
    );
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.getGameTypeID +
      "/seasons/" +
      this.seasonData.slug +
      "/img/misc/"
    );
  }
  get getVideoPath(): string {
    return (
      "/gametype/" +
      this.getGameTypeID +
      "/seasons/" +
      this.seasonData.slug +
      "/video/misc/"
    );
  }
  get getSavePanelLock(): boolean {
    if (this.isSavedOrDiscard) {
      this.showSavePanel = false;
      return false;
    } else {
      return this.showSavePanel;
    }
  }

  get getIntroData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    if (this.seasonData.intro !== undefined) {
      challengeData.text = this.seasonData.intro.intro_t.en;
      challengeData.image = this.seasonData.intro.intro_img || "";
      challengeData.audio = this.seasonData.intro.intro_audio || { en: "" };
      challengeData.video = this.seasonData.intro.intro_video || { en: "" };
    }
    return challengeData;
  }

  get getOutroData(): ChallengeData {
    const challengeData = {} as ChallengeData;
    if (this.seasonData.intro !== undefined) {
      challengeData.text = this.seasonData.outro.outro_t.en;
      challengeData.image = this.seasonData.outro.outro_img || "";
      challengeData.audio = this.seasonData.outro.outro_audio || { en: "" };
      challengeData.video = this.seasonData.outro.outro_video || { en: "" };
    }
    return challengeData;
  }

  created(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  onIntroDataChange(data: ChallengeData): void {
    this.seasonData.intro.intro_img = data.image;
    this.seasonData.intro.intro_t = { en: data.text };
    this.seasonData.intro.intro_audio = data.audio;
    this.seasonData.intro.intro_video = data.video;
    this.onValueChanged();
  }

  onOutroDataChange(data: ChallengeData): void {
    this.seasonData.outro.outro_img = data.image;
    this.seasonData.outro.outro_t = { en: data.text };
    this.seasonData.outro.outro_audio = data.audio;
    this.seasonData.outro.outro_video = data.video;
    this.onValueChanged();
  }

  onValueChanged(): void {
    var data = {
      type: "Intro",
      seasonData: this.seasonData,
      selectable: true,
    };
    if (!isEqual(this.seasonData, this.seasonDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", data);
  }

  @Watch("isEditingLocked")
  onIsEditingLockedChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
}

export default GameTypeIntro;
